import { render, staticRenderFns } from "./AuthorsFilter.vue?vue&type=template&id=7335a9be&scoped=true&"
import script from "./AuthorsFilter.vue?vue&type=script&lang=js&"
export * from "./AuthorsFilter.vue?vue&type=script&lang=js&"
import style0 from "./AuthorsFilter.vue?vue&type=style&index=0&id=7335a9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7335a9be",
  null
  
)

export default component.exports